import {
  PortableTextListItemComponent,
  PortableText as ReactPortableText,
} from "@portabletext/react";
import React from "react";

const ColorComponent = (props: any) => {
  return <span style={{ color: props.value.hex }}>{props.text}</span>;
};

const marksComponents = {
  color: ColorComponent,
};

const listItemComponents:
  | PortableTextListItemComponent
  | Record<string, PortableTextListItemComponent | undefined>
  | undefined = {
  bullet: ({ children }) => (
    <li className="list-disc list-inside">{children}</li>
  ),
};

function PortableText({ value }: { value: any }) {
  return (
    <ReactPortableText
      value={value}
      components={{
        marks: marksComponents,
        listItem: listItemComponents,
        block: {
          normal: ({ children }: any) => {
            if (children.length === 1 && children[0] === "") {
              return <br />;
            }
            return <p>{children}</p>;
          },
          h1: ({ children }: any) => {
            return (
              <div className="text-3xl md:text-6xl  font-bold">{children}</div>
            );
          },
          h2: ({ children }: any) => {
            return (
              <div className="text-3xl md:text-5xl font-bold">{children}</div>
            );
          },
          h3: ({ children }: any) => {
            return (
              <div className="text-3xl md:text-4xl font-bold">{children}</div>
            );
          },
          h4: ({ children }: any) => {
            return (
              <div className="text-3xl md:text-3xl font-bold">{children}</div>
            );
          },
          h5: ({ children }: any) => {
            return (
              <div className="text-3xl md:text-2xl font-bold">{children}</div>
            );
          },
          h6: ({ children }: any) => {
            return (
              <div className="text-3xl md:text-xl font-bold">{children}</div>
            );
          },
        },
      }}
    ></ReactPortableText>
  );
}

export default PortableText;
